import { Box, Grid, Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import StepConnector, { stepConnectorClasses } from "@mui/material/StepConnector";
import StepLabel, { stepLabelClasses } from "@mui/material/StepLabel";
import { styled } from "@mui/material/styles";
import { useSelector } from "react-redux";
import warningIcon from "../../../../assets/icons/Warning.svg";
import { Spinner } from "../../../../components/shared/LoadingSpinner/Spinner";
import { COMMIT_FAILED } from "../../../../Constants/constants";
import { normalizeInstallationOrderType } from "../../../../Services/helper";
import { CardHeading, StepperBox, StyledA, TrackOrderBox } from "../../../../Styles/GlobalStyles";
import { Theme } from "../../../../Styles/GlobalTheme";
import { InstallationStatusTracker } from "./InstallationStatusTracker";
import { SelfInstallStatusTracker } from "./SelfInstallStatusTracker";

export const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: "white",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: "white",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 2,
    border: `2px dashed ${Theme.palette.customcolor.whiteColor}`,
  },
}));

export const ColorlibStepIconRoot = styled("div")<{
  ownerState: { completed?: boolean; active?: boolean };
}>(({ theme, ownerState }) => ({
  backgroundColor: Theme.palette.customcolor.whiteColor,
  width: 50,
  height: 50,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.active && {
    border: `4px solid ${Theme.palette.customcolor.lightGreen}`,
    boxShadow: `1px 1px 30px 4px ${Theme.palette.customcolor.whiteColor}`,
  }),
  ...(ownerState.completed && {
    backgroundColor: "none",
  }),
}));

export const ColorlibStepLabel = styled(StepLabel)(() => ({
  [`& .${stepLabelClasses.label}`]: {
    [`&.${stepLabelClasses.completed}`]: {
      fontWeight: 600,
      color: Theme.palette.customcolor.whiteColor,
    },
    [`&.${stepLabelClasses.active}`]: {
      fontWeight: 600,
      color: Theme.palette.customcolor.whiteColor,
    },
    color: Theme.palette.customcolor.whiteColor,
  },
}));

export const TrackOrder = (props: any) => {
  const { orderDetailsLoading } = props;
  const orderDetails = useSelector((state: any) => state?.customerInfoDetails?.orderDetails);

  // Dispatch (technician) orders get the technician tracker and map; every other order type
  // gets the self-install tracker (same rule as the mobile app).
  const isDispatch = normalizeInstallationOrderType(orderDetails?.orderType) === "dispatch";

  return (
    <>
      <CardHeading>Installation Status</CardHeading>
      <TrackOrderBox>
        {orderDetailsLoading ? (
          <Box py={10}>
            <Spinner />
          </Box>
        ) : orderDetails?.orderStatus === COMMIT_FAILED ? (
          <StepperBox
            sx={{
              backgroundColor: Theme.palette.secondary.main,
              borderRadius: 2,
            }}>
            <Grid container justifyContent={"space-between"}>
              <Grid item>
                <Typography
                  color={"white"}
                  fontWeight={600}
                  component={"p"}
                  fontSize="large"
                  data-testid="status">
                  {orderDetails?.orderStatusMessage}
                </Typography>
                <Typography component={"p"} color={"white"} variant="body2" data-testid="message">
                  Order number&nbsp;{orderDetails?.orderId}
                </Typography>
              </Grid>
            </Grid>

            <Stack justifyContent={"center"} alignItems={"center"} my={1}>
              <img src={warningIcon} alt="warning" height={60} />
              <Typography color={Theme.palette.customcolor.whiteColor} textAlign={"center"}>
                The system couldn't process your reschedule request. We've forwarded it to our
                support team.
              </Typography>
              <Typography
                color={Theme.palette.customcolor.whiteColor}
                textAlign={"center"}
                component={"div"}
                fontSize={{ xs: "14px", md: "16px" }}>
                For any questions, please contact us at :&nbsp;
                <StyledA href="tel:1-866-699-4759">1.866.699.4759</StyledA>
              </Typography>
            </Stack>
          </StepperBox>
        ) : isDispatch ? (
          <InstallationStatusTracker orderDetails={orderDetails} />
        ) : (
          <SelfInstallStatusTracker orderDetails={orderDetails} />
        )}
      </TrackOrderBox>
    </>
  );
};
